import React, { useState } from 'react'
import { Section, HomeLogos, TextButtonWithDropdownArrow } from 'newComponents'
import { ReactComponent as PlanetLeft } from '../../images/_background-stars/planet-orbit.svg'

import './styles.scss'

const ImageSlice = (props) => {
  const { data } = props
  const { primary, items } = data
  const { title, tagline, no_bg_graphics: noBg, is_large_grid: isLgGrid } = primary
  const [open, setOpen] = useState(false)

  const setOpenHandler = () => {
    setOpen(!open)
  }

  // content checks
  const titleHtml = title?.html
  const taglineHtml = tagline?.html
  if (!items) return null

  return (
    <Section className={`logo-grid ${noBg ? 'no-bg' : ''} ${isLgGrid ? 'large-grid' : ''}`}>
      <PlanetLeft className="logo-grid-planet" />
      {taglineHtml && <div className="logo-grid-tagline" dangerouslySetInnerHTML={{ __html: taglineHtml }} />}
      {titleHtml && <div className="logo-grid-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
      <div className={`${open ? 'open' : ''}`}>
        <HomeLogos logos={items} />
      </div>
      {isLgGrid && (
        <TextButtonWithDropdownArrow
          to="#customer-page-banner"
          onClick={setOpenHandler}
          text={`See ${open ? ' Fewer ' : ' More '}Teams`}
        />
      )}
    </Section>
  )
}

export default ImageSlice
